import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AutopairingState } from './autopairing.reducer';

export const autopairingState = createFeatureSelector<AutopairingState>('autopairing');

export const getGlobalConfig = createSelector(autopairingState, state => state.global);

export const getTabIndex = createSelector(autopairingState, state => state.tabIndex);

// Operational Footprint

export const getOperationalFootprints = createSelector(
  autopairingState,
  (state: AutopairingState) => state.operationalFootprintState.operationalFootprints
);

// Transit Program Search

export const getTransitPrograms = createSelector(
  autopairingState,
  (state: AutopairingState) => state.transitProgramSearchState.transitPrograms
);

export const getTransitProgramSearchString = createSelector(
  autopairingState,
  (state: AutopairingState) => state.transitProgramSearchState.searchString
);

export const getTransitProgramsPageSize = createSelector(
  autopairingState,
  (state: AutopairingState) => state.transitProgramSearchState.transitProgramsPageSize
);

export const getTransitProgramsPageIndex = createSelector(
  autopairingState,
  (state: AutopairingState) => state.transitProgramSearchState.transitProgramsPageIndex
);

export const getShouldShowTransitProgramsLoader = createSelector(
  autopairingState,
  (state: AutopairingState) => state.transitProgramSearchState.shouldShowTransitProgramsLoader
);

// Transit Program Configuration

export const getSelectedTransitProgram = createSelector(
  autopairingState,
  (state: AutopairingState) => state.transitProgramSearchState.selectedTransitProgram
);

export const getOperationalFootprintConfig = createSelector(
  autopairingState,
  (state: AutopairingState) => state.operationalFootprintConfig
);

export const getSelectedOperationalFootprint = createSelector(
  autopairingState,
  (state: AutopairingState) => state.operationalFootprintState.selectedOperationalFootprint
);
export const getTransitProgramConfig = createSelector(autopairingState, state => state.transitProgramConfig);
